import { createSlice } from '@reduxjs/toolkit';

export const privacyPagePermissionSlice = createSlice({
  name: 'privacyPagePermission',
  initialState: {
    isCreatePolicyModelVisible: false,
    CreateFromTemplate: false,
  },
  reducers: {
    setisCreatePolicyModelVisible(state) {
      state.isCreatePolicyModelVisible = true;
    },
    setCreatePolicyModelInvisible(state) {
      state.isCreatePolicyModelVisible = false;
    },
    setCreateFromTemplate(state) {
      state.CreateFromTemplate = true;
    },
    setCreateFromTemplateFalse(state) {
      state.CreateFromTemplate = false;
    },
  },
});

export const {
  setisCreatePolicyModelVisible,
  setCreateFromTemplate,
  setCreatePolicyModelInvisible,
  setCreateFromTemplateFalse,
} = privacyPagePermissionSlice.actions;
export default privacyPagePermissionSlice.reducer;
